import { jsx, jsxs } from "react/jsx-runtime";
import { ConfirmActionDialogWidget } from "@brandclub/bc-widgets";
const ConfirmActionDialog = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel
}) => {
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ConfirmActionDialogWidget,
    {
      widgetId: "concierge-confirm-action-dialog",
      displayName: "Confirm Action Dialog",
      overlay: (state, resolveColor) => /* @__PURE__ */ jsx(
        "div",
        {
          style: { backgroundColor: resolveColor(state.overlayBgColor) },
          className: "tw:fixed tw:inset-0 tw:z-[10000]",
          onClick: onCancel
        }
      ),
      children: (state, resolveColor) => /* @__PURE__ */ jsx(
        "div",
        {
          className: "tw:fixed tw:inset-0 tw:z-[10001] tw:flex tw:items-center tw:justify-center tw:px-4",
          onClick: onCancel,
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                backgroundColor: resolveColor(state.dialogBgColor),
                borderRadius: 10,
                padding: "24px 15px 16px 24px",
                width: "100%",
                maxWidth: 480,
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)"
              },
              onClick: (event) => event.stopPropagation(),
              children: [
                /* @__PURE__ */ jsx(
                  "p",
                  {
                    style: {
                      color: resolveColor(state.titleColor),
                      fontSize: 15,
                      fontWeight: 400,
                      lineHeight: "22px",
                      margin: 0
                    },
                    children: title
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      color: resolveColor(state.messageColor),
                      fontSize: 15,
                      fontWeight: 400,
                      lineHeight: "22px",
                      marginTop: 8
                    },
                    children: message
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24 }, children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: onCancel,
                      style: {
                        backgroundColor: resolveColor(state.cancelButtonBgColor),
                        borderColor: resolveColor(state.cancelButtonBorderColor),
                        color: resolveColor(state.cancelButtonTextColor),
                        border: `1px solid ${resolveColor(state.cancelButtonBorderColor)}`,
                        borderRadius: 9999,
                        height: 40,
                        padding: "0 24px",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        cursor: "pointer",
                        boxSizing: "border-box"
                      },
                      children: cancelText
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: onConfirm,
                      style: {
                        backgroundColor: resolveColor(state.confirmButtonBgColor),
                        color: resolveColor(state.confirmButtonTextColor),
                        border: "none",
                        borderRadius: 9999,
                        height: 40,
                        padding: "0 24px",
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        cursor: "pointer",
                        boxSizing: "border-box"
                      },
                      children: confirmText
                    }
                  )
                ] })
              ]
            }
          )
        }
      )
    }
  );
};
export {
  ConfirmActionDialog
};
//# sourceMappingURL=ConfirmActionDialog.js.map
